import { useEffect, useState } from 'react';
import { findOpenOverlay } from './overlayBack';

/**
 * useOpenOverlay - da li je trenutno otvoren neki side panel / modal preko
 * celog ekrana (bilo koji element sa „overlay" u nazivu klase - vidi
 * overlayBack.js).
 *
 * Koristi se u zaglavlju (Shell): dok je panel otvoren, na mobilnom prikazu
 * „nazad" strelica zamenjuje hamburger (tap na nju zatvara panel).
 *
 * Paneli se otvaraju/zatvaraju klikom ili promenom klase/stila (npr. `.open`),
 * pa stanje usaglašavamo sa stvarnim DOM-om preko MutationObserver-a uz blago
 * odlaganje (da uhvatimo i animacije otvaranja/zatvaranja).
 */
const useOpenOverlay = () => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  useEffect(() => {
    let frame = 0;
    let timer = 0;

    const sync = () => {
      frame = 0;
      window.clearTimeout(timer);
      timer = 0;
      setIsOverlayOpen(Boolean(findOpenOverlay()));
    };

    const scheduleSync = (delay = 60) => {
      if (!frame) frame = window.requestAnimationFrame(sync);
      window.clearTimeout(timer);
      timer = window.setTimeout(sync, delay);
    };

    const observer = new MutationObserver(() => scheduleSync());
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden'],
    });

    window.addEventListener('resize', scheduleSync);
    sync();

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', scheduleSync);
      if (frame) window.cancelAnimationFrame(frame);
      window.clearTimeout(timer);
    };
  }, []);

  return isOverlayOpen;
};

export default useOpenOverlay;
